import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService, Notification } from '../core/services/notification.service';
import { Observable } from 'rxjs';
import { PunchNotification } from '../core/services/stomp-websocket.service';
import { MatDialog } from '@angular/material/dialog';
import { PunchDialogComponent } from '../shared/punch-dialog/punch-dialog.component';
import { PunchCreateEditMode } from '@completion/enums';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationContainerComponent {
  notifications$: Observable<Notification[]> = this.notifications.notifications$;

  constructor(
    private readonly notifications: NotificationService,
    private readonly dialog: MatDialog,
  ) {}

  dismiss(id: number): void {
    this.notifications.dismiss(id);
  }

  onOpenPunch(punch: PunchNotification): void {
    this.dialog.open(PunchDialogComponent, {
      width: '900px',
      data: { punch, editMode: PunchCreateEditMode.ViewPunch },
    });
  }
}
